import AppTitle from "@/components/AppTitle/Component";

export default AppTitle;
